import { toast } from 'sonner';
import { usePathname } from 'expo-router';

import { useFeedbackModal } from './states';

import { FeedbackBaseModal } from '@/components/feedback-base-modal';
import { client } from '@/client';

export const FeedbackModal = () => {
  const modal = useFeedbackModal();
  const pathname = usePathname();
  const demoName = pathname?.split('/demos/')?.[1];

  const handleSubmit = async ({
    text,
    isAnonymous,
  }: {
    text: string;
    isAnonymous: boolean;
  }) => {
    await client.post('/feedback/submit', {
      feedback: text,
      isAnonymous,
      demoName,
    });
    toast.success('Thank you for your feedback!');
    modal.close();
  };

  return (
    <FeedbackBaseModal
      isOpen={modal.isOpen}
      onClose={modal.close}
      onSubmit={handleSubmit}
      placeholder="Write your feedback here..."
      submitButtonText="Send Feedback"
    />
  );
};
